<div [ngClass]="showDate ? 'cell-content-active' : 'cell-content'">
  <div>{{ day }}</div>
</div>
